module.exports = __webpack_public_path__ + "media/winner_double_line_3.b31cfd6e.mp3";